export const TOUR_STORAGE_KEY = "moon_scan_mosaic_tour:v1"
/** The intro tour card closes itself after this long, so a visitor who just
 *  arrived from AR is not held at the explanatory overlay. 2 s gives a normal
 *  read of three short gesture lines. */
export const TOUR_AUTO_CLOSE_MS = 2000

export function readTourSeen() {
  try {
    return localStorage.getItem(TOUR_STORAGE_KEY) === "1"
  } catch {
    return false
  }
}

export function writeTourSeen() {
  try {
    localStorage.setItem(TOUR_STORAGE_KEY, "1")
  } catch {
    /* quota / private mode */
  }
}

export function shouldRunTour({seen, hasSlotDive, warming, fromSeam}) {
  if (hasSlotDive || warming) return false
  if (fromSeam) return true
  return !seen
}

export function randomIntroSlot(slotCols, slotRows) {
  const u = 0.22 + Math.random() * 0.56
  const v = 0.22 + Math.random() * 0.56
  return {
    x: Math.min(slotCols - 1, Math.max(0, Math.floor(u * slotCols))),
    y: Math.min(slotRows - 1, Math.max(0, Math.floor(v * slotRows))),
  }
}
